import Component from '../component/component';

export default class AlertExample extends Component {
    static initSelector: string = '.sg-js-alert-example';

    private alert: HTMLElement;
    private addButton: HTMLElement;

    constructor(element: HTMLElement) {
        super(element);

        this.alert = this.element.querySelector('.sg-js-alert-example-alert');
        this.addButton = this.element.querySelector('.sg-js-alert-example-button');

        this.addButton.addEventListener('click', (event: Event) => {
            event.preventDefault();

            this.alert.classList.remove('h-hidden');
        });
    }
}
